import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconTriangleUpComponent } from "./med-icon-triangle-up.component";

@NgModule({
  declarations: [
    MedIconTriangleUpComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconTriangleUpComponent,
  ],
})
export class MedIconTriangleUpModule { }
